import React, { Component } from 'react';
import PropTypes from 'prop-types';
import range from 'lodash.range';
import classnames from 'classnames';

import widgetWrapper from './widgetWrapper';

import { formatTimestamp } from './widgetUtils';

import './TableWidget.scss';

class NewRelicTableWidget extends Component {

  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    details: PropTypes.string,
    table: PropTypes.shape({
      cellAlign: PropTypes.arrayOf(PropTypes.string),
      cellSizes: PropTypes.arrayOf(PropTypes.string),
      head: PropTypes.arrayOf(PropTypes.string),
      body: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        className: PropTypes.string,
      }))),
      hasInnerHTML: PropTypes.bool,
    }),
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fixed: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    title: '',
    subtitle: '',
    table: {
      align: '',
      cellAlign: [],
      cellSizes: [],
      head: '',
      body: [],
      foot: '',
      hasInnerHTML: false,
    },
    details: '',
    timestamp: '',
    fixed: false,
    className: '',
  };

  render() {
    const {
      title,
      subtitle,
      table: {
        align = '',
        cellAlign = [],
        cellSizes = [],
        head = '',
        body = [],
        foot = '',
        // hasInnerHTML = false,
      } = {},
      details,
      timestamp,
      fixed,
      className,
    } = this.props;

    const tableClasses = classnames({
      'align-top': (align === 'top'),
      'align-bottom': (align === 'bottom'),
      fixed: (fixed || (cellSizes.length > 0)),
    });

    return (
      <div className={`TableWidget ${className}`}>
        <div className="header">
          <div className="title">{title}</div>
          <div className="subtitle">{subtitle}</div>
        </div>
        <div className="content">
          <table className={tableClasses}>
            <thead>
              <tr>
                {
                  range(head.length).map(colIndex => (
                    <td
                      key={colIndex}
                      style={
                        cellSizes[colIndex] ? {
                          width: cellSizes[colIndex],
                          textAlign: 'center',
                        } : { textAlign: 'center' }}
                    >
                      {head[colIndex]}
                    </td>
                  ))
                }
              </tr>
            </thead>
            <tbody>
              {
                range(body.length).map(rowIndex => (
                  <tr key={rowIndex}>
                    {
                      range(body[rowIndex].length).map(colIndex => (
                        colIndex === 2 ?
                          <td
                            key={colIndex}
                            style={{ textAlign: cellAlign[colIndex] }}
                            className={body[rowIndex][colIndex].className}
                          >
                            <a target="_blank" rel="noopener noreferrer" href={`${body[rowIndex][4].value}`}>{body[rowIndex][colIndex].value}</a>
                          </td> :
                          <td
                            key={colIndex}
                            style={{ textAlign: cellAlign[colIndex] }}
                            className={body[rowIndex][colIndex].className}
                          >
                            {body[rowIndex][colIndex].value}
                          </td>
                      ))
                    }
                  </tr>
                ))
              }
            </tbody>
            <tfoot>
              <tr>
                {range(foot.length).map(colIndex => (
                  <td
                    key={colIndex}
                    style={{ 'text-align': 'center' }}
                  >
                    {foot[colIndex]}
                  </td>
                ))}
              </tr>
            </tfoot>
          </table>
        </div>
        <div className="footer">
          <div className="details">{details}</div>
          <div className="timestamp">{formatTimestamp(timestamp)}</div>
        </div>
      </div>
    );
  }
}
export default widgetWrapper(NewRelicTableWidget);
